import PageHeader from './components/PageHeader/PageHeader'
import FeaturedCollections from './components/FeaturedCollections/FeaturedCollections'
import SlimBanner from './components/SlimBanner/SlimBanner'
import CollectionBlocks from './components/CollectionBlocks/CollectionBlocks'
import PageFooter from './components/PageFooter/PageFooter'

import jsonData from './data/bundles_data.json'
import './App.scss'

import { slugify } from './helpers/helpers'

const loadData = () => JSON.parse(JSON.stringify(jsonData))
const loadedData = loadData()

console.log('loadedData', loadedData)

const pageSlug = slugify(loadedData.pageName)
const modules = loadedData.modules

let pageHeader
let featuredCollections
let collectionBlocks
let pageFooter

modules.map((m) => {
    if (m.module === 'Page Header') {
        pageHeader = m
    }
    if (m.module === 'Featured Collections') {
        featuredCollections = m
        // console.log('featuredCollections', featuredCollections)
    }
    if (m.module === 'Collection Blocks') {
        collectionBlocks = m
    }
    // if (m.module === 'Page Footer') {
    //     pageFooter = m
    // }
    return null
})

const App = () => {
    return (
        <div id="top-of-page" className={`App Hub-Page ${pageSlug}`}>
            {pageHeader ? (
                <PageHeader data={pageHeader} />
            ) : (
                <div className="loading">Loading...</div>
            )}
            {featuredCollections ? (
                <FeaturedCollections data={featuredCollections} />
            ) : null}
            <SlimBanner />
            {collectionBlocks ? (
                <CollectionBlocks data={collectionBlocks} />
            ) : (
                <div className="loading">Loading...</div>
            )}
            {/*}{pageFooter ? (
                <PageFooter data={pageFooter} />
            ) : (
                <div className="loading">Loading...</div>
            )}*/}
        </div>
    )
}

export default App
